import { Button, Space } from "antd";

import classes from "./style/ButtonGroupStyle.module.css";
import { IButtonGroupStatus } from "../../../interfaces/Application/ButtonGroupStatus/IButtonGroupStatusProps";
import { IButtonConfig } from "../../../interfaces/Application/ButtonGroupStatus/IButtonConfig";

export const ButtonGroupStatus = ({
  onClickModalStatus,
  changeModalVisible,
  modalVisible,
  buttonConfig,
  children,
}: IButtonGroupStatus) => {
  const handleClick = (action: string) => {
    switch (action) {
      case "rejectBank":
        onClickModalStatus("rejected", "Отказ");
        break;
      case "rejectClient":
        onClickModalStatus("rejected_agent", "Отказ от заявки");
        break;
      case "addBanks":
        if (changeModalVisible && typeof modalVisible === "boolean") {
          changeModalVisible(!modalVisible);
        }
        break;
      case "issued":
        onClickModalStatus("issued", "Выпустить заявку");
        break;
      case "forRevision":
        onClickModalStatus("to_rework", "На доработку");
        break;
      case "inWork":
        onClickModalStatus("in_work", "В работе");
        break;
      default:
        break;
    }
  };

  return (
    <Space>
      {buttonConfig?.map((button: IButtonConfig) => {
        if (button) {
          const { label, className, onClick } = button;
          return (
            <Button
              key={label}
              className={classes[className]}
              onClick={() => handleClick(onClick)}
            >
              {label}
            </Button>
          );
        }
      })}
      {children}
    </Space>
  );
};
